import { useMutation } from '@tanstack/react-query'

import type { UpdateResourcePayload } from '@/features/resource/endpoints/resources'
import { updateResource } from '@/features/resource/endpoints/resources'

export function useUpdateResourceMutation(resourceID: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (payload: UpdateResourcePayload) => updateResource(resourceID, payload),
  })

  return {
    updateResource: mutateAsync,
    ...mutationResult,
  }
}
